import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { SessionService } from 'src/app/auth/session.service';
import { AccountStatus } from 'src/app/swagger-api';
import {
  isPrivateConversationWithDeactivatedUser,
  isPrivateConversationWithDeletedUser,
} from '../helpers/chat.helpers';
import { ChatConversation } from '../interfaces/chat-model.interface';

@Component({
  selector: 'app-chat-tabs',
  templateUrl: './chat-tabs.component.html',
  styleUrls: ['./chat-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatTabsComponent {
  @Input({ required: true }) public conversations: ChatConversation[];
  @Input({ required: true }) public activeConversationId: string;
  @Input({ required: true }) public currentUserId: string;

  @Output() public conversationSelected: EventEmitter<ChatConversation> = new EventEmitter<ChatConversation>();

  private sessionService = inject(SessionService);

  public onConversationSelected(conversation: ChatConversation): void {
    this.conversationSelected.emit(conversation);
  }

  public getParticipantsAccountStatus(conversation: ChatConversation): AccountStatus {
    if (isPrivateConversationWithDeactivatedUser(conversation, this.sessionService.userId)) {
      return AccountStatus.DEACTIVATED;
    }

    if (isPrivateConversationWithDeletedUser(conversation, this.sessionService.userId)) {
      return AccountStatus.DELETED;
    }

    return AccountStatus.ACTIVE;
  }

  public isSentByCurrentUser(userId: string): boolean {
    return userId === this.currentUserId;
  }
}
